import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconCropMiddle = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M9.75 4C9.75 3.58579 9.41421 3.25 9 3.25H6.25V11.25H2C1.58579 11.25 1.25 11.5858 1.25 12C1.25 12.4142 1.58579 12.75 2 12.75H6.25V20.75H9C9.41421 20.75 9.75 20.4142 9.75 20C9.75 19.5858 9.41421 19.25 9 19.25H7.75V4.75H9C9.41421 4.75 9.75 4.41421 9.75 4Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.5 12C11.5 12.5523 11.0523 13 10.5 13C9.94771 13 9.5 12.5523 9.5 12C9.5 11.4477 9.94771 11 10.5 11C11.0523 11 11.5 11.4477 11.5 12Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.25 4.75H15C14.5858 4.75 14.25 4.41421 14.25 4C14.25 3.58579 14.5858 3.25 15 3.25H17.75V11.25H22C22.4142 11.25 22.75 11.5858 22.75 12C22.75 12.4142 22.4142 12.75 22 12.75H17.75V20.75H15C14.5858 20.75 14.25 20.4142 14.25 20C14.25 19.5858 14.5858 19.25 15 19.25H16.25V4.75Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.5 13C14.0523 13 14.5 12.5523 14.5 12C14.5 11.4477 14.0523 11 13.5 11C12.9477 11 12.5 11.4477 12.5 12C12.5 12.5523 12.9477 13 13.5 13Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.75 4C9.75 3.58579 9.41421 3.25 9 3.25H6.25V11.25H2C1.58579 11.25 1.25 11.5858 1.25 12C1.25 12.4142 1.58579 12.75 2 12.75H6.25V20.75H9C9.41421 20.75 9.75 20.4142 9.75 20C9.75 19.5858 9.41421 19.25 9 19.25H7.75V4.75H9C9.41421 4.75 9.75 4.41421 9.75 4Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.5 12C11.5 12.5523 11.0523 13 10.5 13C9.94771 13 9.5 12.5523 9.5 12C9.5 11.4477 9.94771 11 10.5 11C11.0523 11 11.5 11.4477 11.5 12Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.25 4.75H15C14.5858 4.75 14.25 4.41421 14.25 4C14.25 3.58579 14.5858 3.25 15 3.25H17.75V11.25H22C22.4142 11.25 22.75 11.5858 22.75 12C22.75 12.4142 22.4142 12.75 22 12.75H17.75V20.75H15C14.5858 20.75 14.25 20.4142 14.25 20C14.25 19.5858 14.5858 19.25 15 19.25H16.25V4.75Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.5 13C14.0523 13 14.5 12.5523 14.5 12C14.5 11.4477 14.0523 11 13.5 11C12.9477 11 12.5 11.4477 12.5 12C12.5 12.5523 12.9477 13 13.5 13Z",
			fill: "currentColor"
		})
	]
});
export { SvgIconCropMiddle as ReactComponent };
